import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { lifeTimeValue: { getLifeTimeValue, } } = apiUrls;

export const LIFE_TIME_VALUE_SUCCESS = 'LIFE_TIME_VALUE_SUCCESS';
export const LIFE_TIME_VALUE_LOADING = 'LIFE_TIME_VALUE_LOADING';


export const getLifeTimeValueData = ({ fromYear, toYear, fromMonth, toMonth, salesChannel,
    vendor }) => async (dispatch) => {

        try {
            if (vendor) {
                const { url } = getLifeTimeValue
                const requestData = {
                    ...getLifeTimeValue,
                    url: url.replace('{{vendor}}', vendor),
                    data: {
                        fromYear,
                        toYear,
                        fromMonth,
                        toMonth,
                        salesChannel
                        }  
                };
                const data = await REQUEST(requestData);
                dispatch({
                    type: LIFE_TIME_VALUE_SUCCESS,
                    data,
                    vendor
                })
            }

        } catch (e) {

            dispatch({
                type: LIFE_TIME_VALUE_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }
    }

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: LIFE_TIME_VALUE_LOADING,
            isLoading,
            vendor
        });
    }
}

